import script from "./otp.vue?vue&type=script&setup=true&lang=js"
export * from "./otp.vue?vue&type=script&setup=true&lang=js"

import "./otp.vue?vue&type=style&index=0&id=4dab00c6&lang=scss"

const __exports__ = script;

export default __exports__